/* eslint-disable i18next/no-literal-string --
 * React Query cache keys.
 */
/** Query keys for the `taxonomy-list` slice. */
export const TAXONOMY_LIST_QUERY_KEYS = {
  all: ['taxonomy-lists'] as const,
  list: () => [...TAXONOMY_LIST_QUERY_KEYS.all, 'list'] as const,
  detail: (id: string) => [...TAXONOMY_LIST_QUERY_KEYS.all, 'detail', id] as const,
  usage: (id: string) => [...TAXONOMY_LIST_QUERY_KEYS.all, 'usage', id] as const,
  changeLog: (id: string) => [...TAXONOMY_LIST_QUERY_KEYS.all, 'change-log', id] as const,
  impact: (id: string) => [...TAXONOMY_LIST_QUERY_KEYS.all, 'impact', id] as const,
  blockingSchemas: (id: string) =>
    [...TAXONOMY_LIST_QUERY_KEYS.all, 'blocking-schemas', id] as const,
  standardCatalog: () => [...TAXONOMY_LIST_QUERY_KEYS.all, 'standard-catalog'] as const,
};
